import { render } from "./RequestsReceived.vue?vue&type=template&id=be9e6474&scoped=true"
import script from "./RequestsReceived.vue?vue&type=script&lang=js"
export * from "./RequestsReceived.vue?vue&type=script&lang=js"

import "./RequestsReceived.vue?vue&type=style&index=0&id=be9e6474&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-be9e6474"

export default script